import { render, staticRenderFns } from "./dialogPayBetSimplified.vue?vue&type=template&id=19babc3e"
import script from "./dialogPayBetSimplified.vue?vue&type=script&lang=js"
export * from "./dialogPayBetSimplified.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports